import React from 'react';
import { observer, inject } from 'mobx-react';
import { Grid, withStyles, FormControl, TextField } from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import PageTitle from '../../components/PageTitle/PageTitle';
import IconButton from '@material-ui/core/IconButton';
// import CustomToolbar from "./CustomToolbar";
import * as Icons from '@material-ui/icons';
import { Button } from '@material-ui/core';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import Loader from '../../components/Loader/LoaderView';
import Swal from 'sweetalert2';
import { withTranslation } from 'react-i18next';
import { clearLocalStorage } from '../../utils/common';
import CustomFooter from '../../components/Table/CustomFooter';

const noImageUrl = 'https://airpresense.s3-ap-southeast-1.amazonaws.com/images/no_img_gray.png';

class RouterTypeManager extends React.Component {
  async componentDidMount() {
    const { offset, limit, search, sort, order, action } = this.props.routerType.toJS();
    if (action) {
      await this.props.routerType.getRouterTypeList(offset, limit, search, sort, order);
      this.props.routerType.setAction('action', null);
    } else {
      this.props.routerType.resetData();
      await this.props.routerType.getRouterTypeList();
    }
    await this.props.router.getRouters();
  }

  deleteItem(id) {
    const { t } = this.props;
    Swal.fire({
      html: `<span class="swal-icon">
              <i
                class="fa fa-trash-o fa-3x fa-border"
                style="border: solid .08em #f27474; border-radius: 1.1em; margin-bottom: 35px; margin-top: 22px;">
              </i>
            </span>
            <br/>
            <h4>${t('delete_router_type')}`,
      showCancelButton: true,
      cancelButtonText: `${t('cancel')}`,
      confirmButtonText: `${t('delete')}`,
      reverseButtons: true,
      customClass: {
        container: 'my-swal',
      },
    }).then(async (result) => {
      if (result.value) {
        try {
          const result = await this.props.routerType.deleteRouterType(id);
          if (result.statusCode === 200) {
            Swal.fire({ html: `<h4>${t('delete_success')}`, type: 'success' }).then(async (resultSuccess) => {
              if (resultSuccess.value) {
                await this.props.routerType.getRouterTypeList();
              }
            });
          } else {
            Swal.fire({ html: `<h4>${t('failed_to_delete')}`, type: 'error' });
          }
        } catch (e) {
          if (e.statusCode === 401) {
            clearLocalStorage();
            window.location.href = '/login';
          } else {
            Swal.fire({ html: `<h4>${t('failed_to_delete')}`, type: 'error' });
          }
        }
      }
    });
  }

  createRouterType() {
    const { classes, t } = this.props;
    return (
      <Button
        variant='outlined'
        color='primary'
        onClick={() => this.props.history.push('routertype/create')}
        className={classes.button}
      >
        <Icons.Add />
        {t('create_router_type')}
      </Button>
    );
  }

  titleContent() {
    const { classes, t } = this.props;
    const { search } = this.props.routerType.toJS();
    return (
      <div className={classes.titleBar}>
        <Grid className={classes.search}>
          <FormControl variant='outlined' className={classes.formControl} fullWidth>
            <TextField
              variant='outlined'
              size='small'
              value={search || ''}
              name='search'
              id='search'
              className={classes.contentInput}
              placeholder={t('search')}
              onChange={(e) => this.handleChangeSearch(e)}
            ></TextField>
          </FormControl>
        </Grid>
      </div>
    );
  }

  handleChangeSearch = (event) => {
    const { value } = event.target;
    this.props.routerType.setData('offset', 0, false);
    this.props.routerType.setData('search', value);
  };

  validateTableRow = (data, expectedSize) => {
    return data && Array.isArray(data) && data.length === expectedSize;
  };

  handleChangeRowsPerPage = (value) => {
    this.props.routerType.setData('limit', value);
  };

  handlechangePage = (value) => {
    const { limit } = this.props.routerType.toJS();
    this.props.routerType.setData('offset', value * limit);
  };
  render() {
    const { classes, t } = this.props;
    const { routerTypes, limit, search, sort, order, loading } = this.props.routerType.toJS();
    const { routers } = this.props.router.toJS();
    const page = routerTypes.data ? routerTypes.pagination.page - 1 : 0;
    const count = routerTypes.data ? routerTypes.pagination.count : 0;
    const ARRAYSIZE = 5;
    const columns = [
      {
        name: 'id',
        label: `${t('id')}`,
        options: {
          filter: true,
          sort: true,
          sortDirection: sort === 'id' && order ? order : 'none',
        },
      },
      {
        name: 'imgUrl',
        label: `${t('photo')}`,
        options: {
          filter: false,
          sort: false,
          customBodyRender: (_value, tableMeta) => {
            const row = tableMeta.rowData;
            const imgUrl = this.validateTableRow(row, ARRAYSIZE) ? row[1] : noImageUrl;
            return (
              <div className={classes.imgPreviewContainer}>
                <div
                  className={classNames(classes.imgPreview, classes.rounded)}
                  style={{
                    background: `url("${imgUrl || noImageUrl}") center no-repeat`,
                  }}
                />
              </div>
            );
          },
        },
      },
      {
        name: 'name',
        label: `${t('name')}`,
        options: {
          filter: true,
          sort: true,
          sortDirection: sort === 'name' && order ? order : 'none',
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return <div className={classes.columnWidth200}>{this.validateTableRow(row, ARRAYSIZE) && row[2]}</div>;
          },
        },
      },
      {
        name: 'manufacturer',
        label: `${t('manufacturer')}`,
        options: {
          filter: true,
          sort: true,
          sortDirection: sort === 'manufacturer' && order ? order : 'none',
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return <div className={classes.columnWidth200}>{this.validateTableRow(row, ARRAYSIZE) && row[3]}</div>;
          },
        },
      },
      {
        name: '',
        label: `${t('action')}`,
        options: {
          filter: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            const id = this.validateTableRow(row, ARRAYSIZE) ? row[0] : '';
            const routerType = (routers || []).find((item) => +item.routerType === +id);
            return (
              <div className={classes.actionBox}>
                <Link to={`/app/routertype/${this.validateTableRow(row, ARRAYSIZE) ? row[0] : ''}/view`}>
                  <IconButton title={t('view')}>
                    {' '}
                    <Icons.FormatListBulleted color='primary' />
                  </IconButton>
                </Link>
                <Link
                  to={`/app/routertype/${this.validateTableRow(row, ARRAYSIZE) ? row[0] : ''}/edit`}
                  title={t('edit')}
                >
                  <IconButton>
                    {' '}
                    <Icons.Edit color='primary' />
                  </IconButton>
                </Link>
                <IconButton
                  title={t('delete')}
                  disabled={routerType ? true : false}
                  onClick={() => this.deleteItem(row ? row[0] : '')}
                >
                  <Icons.Delete color={routerType ? 'disabled' : 'primary'} />
                </IconButton>
              </div>
            );
          },
        },
      },
    ];
    return (
      <React.Fragment>
        <Loader loading={loading} />
        <PageTitle title={t('all_router_types')} button={this.createRouterType()}>
          {this.titleContent()}
        </PageTitle>
        <Grid className={classes.mainContain} container spacing={32}>
          <Grid item xs={12}>
            <MUIDataTable
              data={routerTypes.data}
              columns={columns}
              options={{
                count: routerTypes.data ? routerTypes.pagination.count : 0,
                page: routerTypes.data ? routerTypes.pagination.page - 1 : 0,
                searchText: search,
                serverSide: true,
                pagination: true,
                onTableChange: (action, tableState) => {
                  // console.log(action, tableState);
                  switch (action) {
                    case 'changePage':
                      this.props.routerType.setData('offset', tableState.page * tableState.rowsPerPage);
                      // this.props.user.setData('page',tableState.page);
                      break;
                    case 'changeRowsPerPage':
                      this.props.routerType.setData('limit', tableState.rowsPerPage);
                      break;
                    case 'search':
                      this.props.routerType.setData('offset', 0, false);
                      this.props.routerType.setData('search', tableState.searchText);
                      break;
                    case 'sort':
                      const sortList = tableState.announceText.split(' ');
                      this.props.routerType.setData('offset', 0, false);
                      this.props.routerType.setData('sort', sortList[4], false);
                      this.props.routerType.setData('order', sortList[6] === 'descending' ? 'desc' : 'asc');
                      break;
                    default:
                      break;
                  }
                },
                print: false,
                download: false,
                viewColumns: false,
                search: false,
                sortFilterList: true,
                sort: true,
                selectableRows: 'none',
                selectableRowsOnClick: false,
                filter: false,
                filterType: 'dropdown',
                responsive: 'scrollFullHeight',
                rowsPerPageOptions: [10, 15, 50],
                rowsPerPage: limit,
                customFooter: (rowsPerPage, changeRowsPerPage, changePage, textLabels) => {
                  return (
                    <CustomFooter
                      count={count}
                      page={page}
                      rowsPerPage={limit}
                      changeRowsPerPage={this.handleChangeRowsPerPage}
                      changePage={this.handlechangePage}
                      textLabels={textLabels}
                      rowsPerPageOptions={[10, 15, 50]}
                    />
                  );
                },
              }}
            />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

const styles = (theme) => ({
  mainContain: {
    marginTop: '5px',
    padding: 16,
  },
  button: {
    height: '38px',
    margin: theme.spacing.unit / 2,
  },
  imgPreviewContainer: {
    width: '100%',
    position: 'relative',
  },
  imgPreview: {
    backgroundSize: 'contain !important',
    height: '100px',
    border: '1px solid #ced4da',
  },
  actionBox: {
    minWidth: '150px',
  },
  columnWidth200: {
    maxWidth: '200px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  formControl: {
    '& .MuiInputLabel-shrink': {
      transform: 'translate(14px, 10px) scale(1)',
    },
    margin: theme.spacing.unit / 2,
    width: '100%',
    marginLeft: theme.spacing.unit * 2,
  },
  contentInput: {
    '& fieldset': {
      top: '2px',
    },
    '& input': {
      paddingTop: '17px',
      paddingBottom: '9px',
    },
  },
  titleBar: {
    display: 'flex',
    marginTop: '-5px',
  },
  search: {
    width: '300px',
    [theme.breakpoints.down('sm')]: {
      width: '250px',
    },
  },
});

export const page = inject('router', 'routerType')(observer(RouterTypeManager));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
